import { render } from "./MailingBlockArticleEditor.vue?vue&type=template&id=355ac676"
import script from "./MailingBlockArticleEditor.vue?vue&type=script&lang=js"
export * from "./MailingBlockArticleEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__